<template>
    <div class="lms__superadmin_users_profile_edit_activitylog_table">
        <component-table
            :labels="[
                {
                    key: 'eventTitle',
                    title: 'Event',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'createdAt',
                    title: 'Date time',
                    type: 'date',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'description',
                    title: 'Description',
                    type: 'string',
                    sortable: true
                }
            ]"
            :items="items"
            :empty-state-title="'Any training user completes will be shown here'"
            :component-table-item="LmsSuperadminUsersProfileEditActivityLogTableItem"
            @emit-sort="handleSort"
        />
    </div>
</template>

<script>
import ComponentTable from '@/components/default/shared/ComponentTable'
import LmsSuperadminUsersProfileEditActivityLogTableItem from '@/components/lms/superadmin/users/profile/edit/LmsSuperadminUsersProfileEditActivityLogTableItem'

export default {
  name: 'lms-superadmin-users-profile-edit-activity-log-table',
  components: { ComponentTable },
  data () {
    return {
      LmsSuperadminUsersProfileEditActivityLogTableItem
    }
  },
  props: {
    items: {
      type: Array
    }
  },
  methods: {
    handleSort (data) {
      this.$emit('emit-sort', data)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/user/account/_lmsuseraccountactivitylogtable.scss";
</style>
